import { useEffect } from 'react';

import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import type { MalleableUiPlugin } from '../../malleableUiPluginType';
import { getInlineRemixMetadata } from '../utils/get-inline-remix-metadata';

/** Supplies metadata when lifecycle admission is unavailable, without admitting an edit. */
export const EditorInlineRovoEditMetadataHost = ({
	api,
}: {
	api: ExtractInjectionAPI<MalleableUiPlugin> | undefined;
}): null => {
	const isMetadataEnabled = isExperimentEnabled('maui_remix_feature_area_by_type_exp_gate');
	useEffect(() => {
		if (!isMetadataEnabled) {
			return;
		}
		return api?.aiExperience?.actions.registerInlineRovoEditAdmission?.((targetId, editorState) => {
			const remixMetadata = getInlineRemixMetadata(editorState, targetId);
			return { status: 'unavailable', ...(remixMetadata && { remixMetadata }) };
		});
	}, [api, isMetadataEnabled]);

	return null;
};
